import { DatapointVariant } from 'owa-analytics';
import { FolderForestTreeType } from 'owa-favorites-types';
import { getListViewTypeString, getListViewTypeForFolder } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import {
    switchGroupDatapointName,
    navigateFromMeToWeDatapointName,
} from 'owa-group-common/lib/constants';
import { getListViewTypeForGroup } from 'owa-group-mail-list-actions';

export { default as ReactListViewType } from 'owa-service/lib/contract/ReactListViewType';

export default {
    switchMailFolder: {
        name: 'SwitchMailFolder',
        options: {
            isQos: true,
            variant: DatapointVariant.ColdOnly, // Log all the instances after the first instance in every session
        },
        customData: (
            folderId: string,
            treeType: FolderForestTreeType,
            previousFolderId: string,
            actionSource: ActionSource
        ) => [
            folderIdToName(folderId),
            previousFolderId ? folderIdToName(previousFolderId) : '', // previousFolderId can be null when there is no folder selected before switching folder (for example, exiting search)
            treeType,
            actionSource,
            getListViewTypeString(getListViewTypeForFolder(folderId)),
        ],
    },
    selectPersona: {
        name: 'SelectPersona',
    },
    selectPrivateDistributionList: {
        name: 'SelectPrivateDistributionList',
    },
    selectFavoriteSearch: {
        name: 'TnS_SelectFavoriteSearch',
    },
    selectFavoriteCategory: {
        name: 'TnS_SelectFavoriteCategory',
    },
    // This DP measures the loading of Group script
    selectGroup: {
        name: 'SelectGroup',
        options: {
            isQos: true,
        },
    },
    switchGroup: {
        name: switchGroupDatapointName,
        options: {
            isQos: true,
        },
        customData: (groupId: string, treeType: FolderForestTreeType) => ({
            TreeType: treeType,
            ListViewType: getListViewTypeString(getListViewTypeForGroup()),
        }),
    },
    navigateFromMeToWe: {
        name: navigateFromMeToWeDatapointName,
        options: {
            isQos: true,
        },
        customData: (groupId: string, treeType: FolderForestTreeType) => ({
            TreeType: treeType,
            ListViewType: getListViewTypeString(getListViewTypeForGroup()),
        }),
    },
};
